import {
  DataGrid as MuiDataGrid,
} from '@mui/x-data-grid';
import styled from 'styled-components';

const StyledDataGrid = styled(MuiDataGrid)`
  && {
    border: none;
    & .MuiDataGrid-root, & .MuiDataGrid-columnHeaders, & .MuiDataGrid-cell, & .MuiDataGrid-colCell, & .MuiDataGrid-cell, & .MuiDataGrid-cell {
      border: none;
    }
    & .MuiDataGrid-columnHeader {
      // Prevent outline on selection
      outline: none !important;
    }
    & .MuiDataGrid-columnSeparator {
      opacity: 0 !important;
    }
    & .MuiDataGrid-columnHeaderTitle {
      font-weight: bold;
    }
    & .MuiDataGrid-footerContainer {
      border: none !important;
    }
    & .MuiDataGrid-cell {
      cursor: pointer;
      &:focus {
        outline: none;
      }
      &:focus-within {
        outline: none;
      }
    }
    // Round corners
    & .MuiDataGrid-row {
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
      // Prevent alignment shift of selected row
      border: 1px solid transparent;
    }
    // Alternate colors
    & .MuiDataGrid-row:nth-child(even) {
      :not(:hover) {
        background-color: ${({ theme }) => theme.palette.background.paper};
      }
    }
    & .MuiDataGrid-row:nth-child(odd) {
      :not(:hover) {
        background-color: ${({ theme }) => theme.palette.backdrop.main};
      }
    }

    // Repeat styles for clickable rows
    & .LinkRow-MuiDataGrid-row {
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
      :not(:hover) {
        // Override .MuiDataGrid-row:nth-child styling
        background-color: inherit !important;
      }
    }
    & .LinkRow-row {
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    }
    & .LinkRow-row:nth-child(even) {
      :not(:hover) {
        background-color: ${({ theme }) => theme.palette.background.paper};
      }
    }
    & .LinkRow-row:nth-child(odd) {
      :not(:hover) {
        background-color: ${({ theme }) => theme.palette.backdrop.main};
      }
    }

    // Selected row
    & .MuiDataGrid-row--selected {
      border: 1px solid ${({ theme }) => theme.palette.info.main};
    }
  }
`;

export { StyledDataGrid };
